exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".practice-team--3WhN-dsqwM6ra57rurNL4H select {\n  width: 188px;\n}\n\n.practice-team--2f3gN4fiMPwSkEWZVE_CUb {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  z-index: 99;\n}\n\n.practice-team--zv5v-xAaiEwTxFemwJARu {\n  margin: 10px 0px;\n}\n\n.practice-team--3PmYSoWoDAqAiV7eRxzDeK {\n  font-weight: bold;\n  color: #d87f00;\n  white-space: pre-wrap;\n  margin-left: auto;\n}\n", ""]);

// exports
exports.locals = {
	"practice-team-search": "practice-team--3WhN-dsqwM6ra57rurNL4H",
	"practiceTeamSearch": "practice-team--3WhN-dsqwM6ra57rurNL4H",
	"addMenu": "practice-team--2f3gN4fiMPwSkEWZVE_CUb",
	"addMenu": "practice-team--2f3gN4fiMPwSkEWZVE_CUb",
	"addPracticeTeam": "practice-team--zv5v-xAaiEwTxFemwJARu",
	"addPracticeTeam": "practice-team--zv5v-xAaiEwTxFemwJARu",
	"updateMessage": "practice-team--3PmYSoWoDAqAiV7eRxzDeK",
	"updateMessage": "practice-team--3PmYSoWoDAqAiV7eRxzDeK"
};